import * as React from "react";
import type { SVGProps } from "react";
const SvgBaby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#baby_svg__a)">
      <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-18a8 8 0 1 0 0 16 8 8 0 0 0 0-16" />
      <path d="M12 17a4.43 4.43 0 0 1-3.21-1.3 1 1 0 0 1 1.42-1.4 2.52 2.52 0 0 0 3.54 0 1 1 0 1 1 1.44 1.39A4.62 4.62 0 0 1 12 17M12 8a3 3 0 0 1 0-6 1 1 0 1 1 0 2 1 1 0 1 0 0 2 1 1 0 1 1 0 2M10 13a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1M14 13a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1" />
    </g>
    <defs>
      <clipPath id="baby_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBaby;
